import { ApiMetaDataDTO } from 'declarations'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

type ResponseDTO = {
  code: number
  data: number[]
  api_metadata: ApiMetaDataDTO
}

export const useSprSequencesQuery = (): UseQueryResult<number[], unknown> => {
  return useQuery({
    queryKey: ['spr', 'sequences'],
    queryFn: async () => {
      try {
        const res = await client.get<ResponseDTO>(
          '/supplier_preference_rules/sequence/list'
        )
        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
}
